import { setAuthToken, setRefreshToken } from '@/libs/api'
import type { LoginCredentials, LoginResponse } from '@/libs/interfaces'

import { mockOrganization, mockUser } from '../fixtures/seed'
import { delay } from '../helpers'

export const authApiMock = {
  login: async (_credentials: LoginCredentials): Promise<LoginResponse> => {
    setAuthToken('mock-access-token')
    setRefreshToken('mock-refresh-token')
    return delay({
      message: 'Login successful (mock mode)',
      loginSuccess: true,
      accessToken: 'mock-access-token',
      refreshToken: 'mock-refresh-token',
      user: mockUser,
      orgs: [mockOrganization],
    })
  },
  logout: async (): Promise<void> => delay(undefined),
}
